export const categories = [
  {
    name: 'A.I',
    image: 'https://i.pinimg.com/564x/48/bd/1d/48bd1d76baffb3ccf5e630ba66b8624f.jpg',
  },
  {
    name: 'Aliens',
    image: 'https://i.pinimg.com/564x/9a/1f/49/9a1f49c1af5d425885a0a174846eeebc.jpg',
  },
  {
      name: 'Anime',
      image: 'https://i.pinimg.com/564x/6e/ef/9c/6eef9c7c960b41ad8abed1384d2971ee.jpg',
    },
    {
      name: 'Animals',
      image: 'https://i.pinimg.com/564x/51/ce/6a/51ce6a3f68585bb4bf3963a09ea7c323.jpg',
    },
    {
      name: 'Art',
      image: 'https://i.pinimg.com/564x/0e/4a/6e/0e4a6edc701b4de188717a3e7c7445a4.jpg',
    },
    {
      name: '/b/',
      image: 'https://ih1.redbubble.net/image.95870644.0073/pd,x750,macbook_air_13-pad,1000x1000,f8f8f8.jpg',
    },
    {
      name: 'Bible',
      image: 'https://www.usnews.com/dims4/USNEWS/524f085/2147483647/thumbnail/970x647/quality/85/?url=https%3A%2F%2Fwww.usnews.com%2Fcmsmedia%2F49%2Ff3%2F8892adfc47a99f7136acb4711193%2F150121-bible-editorial.jpg',
    },
    {
      name: 'Birthdays',
      image: 'https://i.pinimg.com/originals/55/58/4d/55584d06ff109d0fa24e944b21c4562f.jpg',
    },
    {
      name: 'Books',
      image: 'https://cottagelife.com/wp-content/uploads/2016/01/lushome.com_.jpg',
    },
    {
      name: 'Cars',
      image: 'https://s.hdnux.com/photos/01/25/77/46/22542745/4/rawImage.jpg',
    }, {
      name: 'Code',
      image: 'https://legendary-digital-network-assets.s3.amazonaws.com/wp-content/uploads/2019/06/13101333/The-Matrix-code.jpg',
    },
    {
      name: 'Computers',
      image: 'https://plecom.imgix.net/bo-880215-900x900.jpg?auto=format',
    }, {
      name: 'Countries',
      image: 'https://cdn.theatlantic.com/thumbor/tVLkFmlkO0vr7MmjgPUvlEofHUY=/249x0:1749x1125/1200x900/media/img/mt/2021/06/HappiestCountriesFinal/original.jpg',
    }, {
      name: 'Crypto',
      image: 'https://e00-marca.uecdn.es/assets/multimedia/imagenes/2022/03/16/16474457239222.jpg',
    },
    {
      name: 'Dark',
      image: 'https://www.theshirtlist.com/wp-content/uploads/2019/02/Dark-Passenger.jpg',
    },
    {
      name: 'Depression',
      image: 'https://www.sciencenews.org/wp-content/uploads/2023/02/021123_LS_depression_feat.jpg',
    },
    {
      name: 'Design',
      image: 'https://raw.githubusercontent.com/DXHeroes/knowledge-base-content/master/files/design_thinking.png',
    },
    {
      name: 'Diet',
      image: 'https://askthescientists.com/wp-content/uploads/2019/06/AdobeStock_310581123-1.jpeg',
    },
    {
      name: 'Dreams',
      image: 'https://static1.srcdn.com/wordpress/wp-content/uploads/2019/10/Vikings-The-Seer-1.jpg',
    },
    {
      name: 'Quotes',
      image: 'https://wavebox.io/knowhow/content/images/2022/05/Untitled.010.png',
    },
    {
      name: 'Mortal Kombat',
      image: 'https://bestanimations.com/Games/Computer/MortalCombat/LiuKang/liu-kang-mortal-kombat-animated-gif-2.gif',
    },
    
    {
      name: 'other',
      image: 'https://i.pinimg.com/236x/2e/63/c8/2e63c82dfd49aca8dccf9de3f57e8588.jpg',
    },
  ];
  
  export const feedQuery = `*[_type == "pin"] | order(_createdAt desc) {
    image{
      asset->{
        url
      }
    },
        _id,
        destination,
        postedBy->{
          _id,
          userName,
          image
        },
        save[]{
          _key,
          postedBy->{
            _id,
            userName,
            image
          },
        },
      } `;
  
  export const pinDetailQuery = (pinId) => {
    const query = `*[_type == "pin" && _id == '${pinId}']{
      image{
        asset->{
          url
        }
      },
      _id,
      title, 
      about,
      category,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
     save[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
      comments[]{
        comment,
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      }
    }`;
    return query;
  };
  
  export const pinDetailMorePinQuery = (pin) => {
    const query = `*[_type == "pin" && category == '${pin.category}' && _id != '${pin._id}' ]{
      image{
        asset->{
          url
        }
      },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };
  
  export const searchQuery = (searchTerm) => {
    const query = `*[_type == "pin" && title match '${searchTerm}*' || category match '${searchTerm}*' || about match '${searchTerm}*']{
          image{
            asset->{
              url
            }
          },
              _id,
              destination,
              postedBy->{
                _id,
                userName,
                image
              },
              save[]{
                _key,
                postedBy->{
                  _id,
                  userName,
                  image
                },
              },
            }`;
    return query;
  };
  
  export const userQuery = (userId) => {
    const query = `*[_type == "user" && _id == '${userId}']`;
    return query;
  };
  
  export const userCreatedPinsQuery = (userId) => {
    const query = `*[ _type == 'pin' && userId == '${userId}'] | order(_createdAt desc){
      image{
        asset->{
          url
        }
      },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };
  
  export const userSavedPinsQuery = (userId) => {
    const query = `*[_type == 'pin' && '${userId}' in save[].userId ] | order(_createdAt desc) {
      image{
        asset->{
          url
        }
      },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };